// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1DDzP","head":"ProcedureTableInfo_head__332KN"};